<li class="menu-item level-{{ level() }}">
    <div
        class="menu-item__heading"
        [ngClass]="{
            'menu-item__heading--no-hover': level() === 1,
            'menu-item__heading--is-active': isActiveAnchor(),
        }"
    >
        @if (hasChildren) {
            <button
                class="menu-item__button"
                [ngClass]="{
                    'menu-item__button--is-open': isOpen(),
                }"
                (click)="toggleOpen()"
            ></button>
        }
        @if (url && !item().isAnchor) {
            <a
                class="menu-item__link"
                link-target-detector
                [href]="url"
                [ngClass]="{
                    'menu-item__link--is-active': isOpen(),
                }"
                [innerHTML]="item().title"
            ></a>
        } @else {
            <a
                class="menu-item__link menu-item__link--anchor"
                (click)="anchorClick(item().url)"
                [attr.data-application]="'sb-anchor-' + item().url"
                [ngClass]="{
                    'menu-item__link--is-active': isOpen(),
                }"
                [innerHTML]="item().title"
            ></a>
        }
    </div>

    @if (hasChildren) {
        <ul
            class="menu-item__children"
            [ngClass]="{
                'menu-item__children--is-open': isOpen(),
            }"
        >
            @for (element of item().children; track element.title) {
                <website-menu-item
                    [parentItem]="item()"
                    [item]="element"
                    [level]="level() + 1"
                    [isFAQItem]="element?.url?.includes('faq/')"
                ></website-menu-item>
            }
        </ul>
    }
</li>
